import React from "react";
import {
  Container,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  InputAdornment,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useFetch from "../utils/UseFetch";
import { useNavigate } from "react-router-dom";
import { token, itemPrequalifications } from "../HelperFx/datalinks";

const eq = " eq ";

const ItemPrequalifications = () => {
  const vendorNo = sessionStorage.getItem("vendorNo");
  const navigate = useNavigate();
  const {
    data: itemsLines,
    loading,
    error,
  } = useFetch(
    `${itemPrequalifications}&$filter=rfpVendorNo${eq}'${vendorNo}'`,
    token,
  );

  // Process the data to create Bids array in reverse order
  const Prequalifications = React.useMemo(() => {
    if (!itemsLines?.value) return [];

    return itemsLines.value.reverse(); // Reverse the array to show newest first
  }, [itemsLines]);

  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredPrequalifiquations = Prequalifications.filter(
    (preqn) =>
      preqn.no.toLowerCase().includes(searchTerm.toLowerCase()) ||
      preqn.relatedPartyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      preqn.originatingDocumentNo
        .toLowerCase()
        .includes(searchTerm.toLowerCase()),
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4, ml: 0 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search bids..."
          sx={{ mr: 2 }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {loading && <Typography>Loading Item Prequalifications...</Typography>}
      {error && (
        <Typography color="error">
          Error loading Prequalifications: {error.message}
        </Typography>
      )}

      {filteredPrequalifiquations.length === 0 && !loading && (
        <Typography>
          No Item Prequalification found for your vendor account.
        </Typography>
      )}

      {filteredPrequalifiquations.map((prequaln, index) => (
        <Card key={index} sx={{ mb: 2, width: "100%", height: "100px" }}>
          <CardContent>
            <Typography variant="h6" color="primary" sx={{ fontSize: 15 }}>
              <a
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(`/itemprequalification`, {
                    state: { PreqNo: prequaln.no },
                  })
                }
              >
                {prequaln.no} -{prequaln.originatingDocumentNo}
              </a>
            </Typography>
            <Typography variant="body1" sx={{ mt: 0 }}>
              {prequaln.relatedPartyName}
            </Typography>
            <Box sx={{ mt: 1, fontStyle: "italic", color: "gray" }}>
              Status: {prequaln.qAStage}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default ItemPrequalifications;
